import { Icon } from "./Icon.tsx";

/** A triangle-exclamation glyph — the sample-project reminder
 *  (ExampleBanner.tsx) collapsed to icon form, and available for any
 *  future "needs attention" indicator that isn't a full simulation
 *  warning. */
export function WarningIcon() {
  return (
    <Icon>
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Icon>
  );
}
